export function getEnumValues<Type = string>(data: Record<string, Type>): Type[] {
  return Object.keys(data).map((key) => data[key]);
}
